import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import ResponsiveTabs from 'components/ResponsiveTabs/ResponsiveTabs';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { jsPDF } from 'jspdf';
import jsonToTable from 'json-to-table';
import GrillaEffect from 'views/Grillas/GrillaEffect';
import dayjs from 'dayjs';
import DataLabel from 'views/Cards/DataLabel';

function AporteCapital() {
  const url = `${process.env.REACT_APP_API_URL}/querysextgrilla/`;
  const defaultFecha = [
    { id: 'periodo_cobranza', value: dayjs().subtract(1, 'month').format('YYYY-MM') }
  ];
  const [dataFacturadoPeriodo, setDataFacturadoPeriodo] = useState([]);
  const [dataFacturadoPeriodoConcepto, setDataFacturadoPeriodoConcepto] = useState([]);
  const [dataCobradoPeriodo, setDataCobradoPeriodo] = useState([]);
  const [dataCobradoPeriodoConcepto, setDataCobradoPeriodoConcepto] = useState([]);

  const [filterFacturado, setFilterFacturado] = useState([...defaultFecha]);
  const [filterCobrado, setFilterCobrado] = useState([...defaultFecha]);

  const [tab, setTab] = useState(0);
  const [tabFac, setTabFac] = useState(0);
  const [tabCob, setTabCob] = useState(0);

  const colsFactCapital = {
    periodo_facturacion: { caption: 'Pdo. Facturacion', enableColumnFilter: true },
    concepto: { caption: 'Cpto.', enableColumnFilter: true },
    importe: { caption: 'Importe', enableColumnFilter: false },
  };
  const colsCobrCapital = {
    periodo_cobro: { caption: 'Pdo. Cobro', enableColumnFilter: true },
    importe: { caption: 'Importe', enableColumnFilter: false },
  };

  const colsPdoEnteDia = {
    periodo_cobranza: { caption: 'Pdo. Cobranza', enableColumnFilter: true },
    dia_cobranza: { caption: 'Dia Cobranza', enableColumnFilter: true },
    ente: { caption: 'Ente', enableColumnFilter: true },
    importe: { caption: 'Importe', enableColumnFilter: false },
  };

  const colsPdoDia = {
    periodo_cobranza: { caption: 'Pdo. Cobranza', enableColumnFilter: true },
    dia_cobranza: { caption: 'Dia Cobranza', enableColumnFilter: true },
    importe: { caption: 'Importe', enableColumnFilter: false },
  };

  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
  });
  const GenerarCsv = async () => {
    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/19`;
      const rest = await fetch(baseURL, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
        body: JSON.stringify({
          fdesde: new Date(startDate).toLocaleDateString(),
          fhasta: new Date(endDate).toLocaleDateString()
        })
      });
      const resulte = await rest.json();
      const csv = generateCsv(csvConfig)(resulte);
      download(csvConfig)(csv);
    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }
  };

  const GenerarPdf = async () => {
    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/19`;
      const rest = await fetch(baseURL, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
        body: JSON.stringify({
          fdesde: new Date(startDate).toLocaleDateString(),
          fhasta: new Date(endDate).toLocaleDateString()
        })
      });
      const resulte = await rest.json();
      const tabled = jsonToTable(resulte);
      let nombresCampos = tabled[0];
      let datos = tabled.shift();
      const doc = new jsPDF();
      doc.autoTable({
        head: [nombresCampos],
        body: tabled,
        margin: { top: 10 },
        styles: {
          minCellHeight: 4,
          halign: 'left',
          valign: 'center',
          fontSize: 4,
        },
      });
      doc.save('pdf-cobranzas.pdf');
    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pt: '120px' }}>
      <Card>
        <CardBody>
          {/* KPI Cards */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <Card minH='110px'>
                <CardBody px='2px'>
                  <DataLabel url={url + '?id=' + 64} columns={colsPdoEnteDia} filters={filterFacturado} label={"TOTAL COBRADO"} />
                </CardBody>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Card minH='110px'>
                <CardBody px='2px'>
                  <DataLabel filters={filterFacturado} isMoney={false} countDateColumn={'periodo_cobranza'} countDayColumn={'dia_cobranza'} label={"CANTIDAD DE DIAS"} />
                </CardBody>
              </Card>
            </Grid>
            {/* BOTONES EXPORTAR — pendiente activar
            <Grid item xs={12} sm={6}>
              <Card minH='110px'>
                <CardBody>
                  (botones futuros aquí)
                </CardBody>
              </Card>
            </Grid>
            */}
          </Grid>
          <Card sx={{ p: 2, my: 3 }}>
            <CardBody>
              <ResponsiveTabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                tabs={[
                  { label: 'Facturado' },
                  { label: 'Cobrado' },
                ]}
              />

              {tab === 0 && (
                <Box pt={1}>
                  <ResponsiveTabs
                    value={tabFac}
                    onChange={(_, v) => setTabFac(v)}
                    tabs={[
                      { label: 'Por Periodo' },
                      { label: 'Por Periodo y Conceptos' },
                    ]}
                  />
                  {tabFac === 0 && (
                    <Box pt={1}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                        <GrillaEffect
                          data={dataFacturadoPeriodo} updateData={setDataFacturadoPeriodo}
                          filters={filterFacturado} updateFilters={setFilterFacturado}
                          idRemoto={73}
                          colsHeaders={colsFactCapital}
                          defaultSorting={[
                            { id: 'periodo_facturacion', desc: true },
                          ]} />
                      </LocalizationProvider>
                    </Box>
                  )}
                  {tabFac === 1 && (
                    <Box pt={1}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                        <GrillaEffect
                          data={dataFacturadoPeriodoConcepto} updateData={setDataFacturadoPeriodoConcepto}
                          filters={filterFacturado} updateFilters={setFilterFacturado}
                          idRemoto={74}
                          colsHeaders={colsFactCapital}
                          defaultSorting={[
                            { id: 'periodo_facturacion', desc: true },
                          ]} />
                      </LocalizationProvider>
                    </Box>
                  )}
                </Box>
              )}

              {tab === 1 && (
                <Box pt={1}>
                  <ResponsiveTabs
                    value={tabCob}
                    onChange={(_, v) => setTabCob(v)}
                    tabs={[
                      { label: 'Por Periodo' },
                    ]}
                  />
                  {tabCob === 0 && (
                    <Box pt={1}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                        <GrillaEffect
                          data={dataCobradoPeriodo} updateData={setDataCobradoPeriodo}
                          filters={filterCobrado} updateFilters={setFilterCobrado}
                          idRemoto={75}
                          colsHeaders={colsCobrCapital}
                          defaultSorting={[
                            { id: 'periodo_cobro', desc: true },
                          ]} />
                      </LocalizationProvider>
                    </Box>
                  )}
                </Box>
              )}
            </CardBody>
          </Card>
        </CardBody>
      </Card>
    </Box>
  );
}

export default AporteCapital;
